import './footer.scss';

import { TextColorCheck } from '../utils/textColorCheck';

const COMPONENT_NAME = 'tcl-footer';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_FOOTER_CTALIST: 'tcl-footer__cta-list',
};

/**
 * version    1.0
 * class      <type> (Footer)
 * classdesc  Main footer
 */
export class Footer {
  constructor() {
    this._findUIElements();
    this._bindEvents();
  }

  // private methods

  _findUIElements() {
    this._els = {
      footer: $(`.${BEM.BLOCK}`),
      footerCtaList: $(`.${BEM.ELEMENT_FOOTER_CTALIST}`),
    };
  }

  _bindEvents() {
    const self = this;
    self._detectSingleCta();
    TextColorCheck._checkBackground(self._els.footer);
  }

  _isSingleCTA(ctalist) {
    return ctalist.find('.tcl-footer__cta').length === 1;
  }

  _detectSingleCta() {
    const self = this;
    self._els.footerCtaList.each(function () {
      if (self._isSingleCTA($(this))) {
        $(this).closest('.tcl-footer__column').addClass('single-cta');
        const title = $(this).prev().text();
        const relatedLink = $(this).find('.tcl-footer__cta a');
        relatedLink.attr('aria-label', `${title} - ${relatedLink.text()}`);
      }
    });
  }
}
